import React from 'react';

export interface AppleBrandIconProps {
  size?: number;
  'aria-hidden'?: boolean;
}

export const AppleBrandIcon: React.FC<AppleBrandIconProps> = ({
  size = 24,
  'aria-hidden': ariaHidden = true,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={size}
    height={size}
    fill="none"
    aria-hidden={ariaHidden}
  >
    <path
      fill="currentColor"
      d="M20.4024 7.4998C20.2745 7.5988 18.0168 8.8682 18.0168 11.6908C18.0168 14.9556 20.8897 16.1106 20.9756 16.1392C20.9624 16.2096 20.5193 17.721 19.461 19.261C18.5173 20.6162 17.5318 21.9692 16.0325 21.9692C14.5333 21.9692 14.1474 21.1002 12.4167 21.1002C10.73 21.1002 10.1303 21.9978 8.75893 21.9978C7.38755 21.9978 6.43068 20.7438 5.33049 19.2038C4.05612 17.3954 3.02649 14.586 3.02649 11.9196C3.02649 7.6428 5.81334 5.3746 8.55609 5.3746C10.0135 5.3746 11.2283 6.3294 12.1433 6.3294C13.0142 6.3294 14.3723 5.3174 16.0303 5.3174C16.6587 5.3174 18.9164 5.3746 20.4024 7.4998ZM15.2432 3.5068C15.9289 2.695 16.4139 1.5686 16.4139 0.4422C16.4139 0.286 16.4007 0.1276 16.3721 0C15.2564 0.0418 13.9291 0.7414 13.1288 1.6676C12.5004 2.3804 11.914 3.5068 11.914 4.6486C11.914 4.8202 11.9426 4.9918 11.9559 5.0468C12.0264 5.06 12.1411 5.0754 12.2557 5.0754C13.2567 5.0754 14.5156 4.4066 15.2432 3.5068Z"
    />
  </svg>
);
